import { render, staticRenderFns } from "./a-product-quantity-calculator.vue?vue&type=template&id=2203940c&"
import script from "./a-product-quantity-calculator.vue?vue&type=script&lang=js&"
export * from "./a-product-quantity-calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports